import React from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import { Helmet } from 'react-helmet'

function contact() {
  return (
    <>
    <Helmet>
                     <link rel="canonical" href="https://www.lotusaccounting.ca/contact" />
                      <title>
          Contact Lotus Accounting | CPA Firm in Toronto
        </title>
        <meta
          name='description'
          content='Contact Lotus Accounting in Toronto for expert CPA accounting, tax planning, bookkeeping, and business advisory services. Schedule your consultation today.'>
        </meta>
                   </Helmet>
        <CommonBanner
          subHeading=""
          Heading="Contact Lotus Accounting:"
          spanHeading=" Your Partner in Financial Success"
          Paragraph="Our team of talented and experienced Chartered Professional Accountants is here to assist you with complex accounting and tax matters."
          btnText=""
          bgImg="/images/creative/contact-bg.webp"
          btn={false}
          socialLinks={true}
          serviceForm={true}
        />
        <TestimonialForm PartnerCompaniesSection={false}/>
    </>
  )
}

export default contact